export const chamfrLoadingSkeletonMiddleware = ({ instantSearchInstance }) => {
  let skeletonRemoved = false;

  return {
    onStateChange() {},
    subscribe() {
      instantSearchInstance.on("render", () => {
        // Only remove skeleton once
        if (skeletonRemoved) {
          return;
        }

        const widgets = instantSearchInstance.mainIndex
          .getWidgets()
          .filter((w) => typeof w.getIndexId === "function");

        const results = Object.fromEntries(
          widgets.map((w) => [w.getIndexId(), w.getResults() || null])
        );

        // Check if we have results (results object exists with nbHits property)
        const hasResults = Object.values(results).some(
          (result) => result && result.nbHits !== undefined
        );

        if (hasResults) {
          // Remove all skeleton divs
          const skeletonElements = document.querySelectorAll(
            ".chamfr-skeleton"
          );
          skeletonElements.forEach((element) => {
            element.remove();
          });
          skeletonRemoved = true;
        }
      });
    },
    unsubscribe() {},
  };
};

